var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.$t("exportClientsRechargeTransaction"),
      value: _vm.show,
      rightMethod: _vm.exportClientsRechargeTransaction,
      disabledClose: _vm.loading,
      leftMethod: function() {
        return (_vm.show = false)
      },
      rightButtonText: _vm.$t("export"),
      rightButtonDisabled: !_vm.selectedClients.length,
      small: ""
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              { attrs: { "py-0": "", fluid: "" } },
              [
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs4: "" } },
                      [
                        _c("DatePicker", {
                          attrs: { label: _vm.$t("month"), mode: "month" },
                          model: {
                            value: _vm.month,
                            callback: function($$v) {
                              _vm.month = $$v
                            },
                            expression: "month"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _c("v-combobox", {
                          attrs: {
                            label: _vm.$t("organizations"),
                            items: _vm.clients,
                            chipText: "clientName",
                            itemText: "clientName",
                            counter: 10,
                            chips: "",
                            multiple: "",
                            clearable: "",
                            "return-object": ""
                          },
                          model: {
                            value: _vm.selectedClients,
                            callback: function($$v) {
                              _vm.selectedClients = $$v
                            },
                            expression: "selectedClients"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ac8a46ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac8a46ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/exportClientsRechargeTransactionPopup.vue
// module id = null
// module chunks = 